import { atom } from "jotai";
import throttle from 'lodash/throttle';

const getIframeHeight = () => {
  const ordersContainer = document.getElementById('gpc-app');
  if (ordersContainer) {
    return ordersContainer.scrollHeight;
  }
  return document.body.scrollHeight;
};
const getIframeWidth = () =>
  Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.body.clientWidth,
    document.documentElement.clientWidth
  );

  // Atom holding the resize logic as a function
const iframeResizeAtom = atom(null, (get, set) => {
  const sendIframeSizeToParent = throttle(() => {
    if (window.parent !== window) {
      const height = getIframeHeight();
      const width = getIframeWidth();
      window.parent.postMessage({ type: 'IFRAME_SIZE', height, width }, '*');
    }
  }, 100);

  // Create a ResizeObserver
  const resizeObserver = new ResizeObserver(() => {
    sendIframeSizeToParent();
  });

  // Start observing the body element
  const body = document.body;
  if (body) {
    resizeObserver.observe(body);
  }

  // Send height when the function is triggered
  sendIframeSizeToParent();

  // Cleanup observer on unmount
  return () => {
    if (body) {
      resizeObserver.unobserve(body);
    }
  };
});

export { iframeResizeAtom };
